import { selectors } from "reducers/session";
import { store } from "../store";

const getLoggedUserId = () => selectors.getUserId(store.getState());

export default getLoggedUserId;
